import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoginService from "../../../service/login/loginService";
import { IListObj } from "../../../types/genericTypes";
import { AccounTypeSection } from "./common/accountTypeSection";
import { DpTrading } from "./common/dpTrading";

const accTypes: Array<IListObj> = [
  { value: "tradingDemat", display: "Trading + Demat" },
  { value: "demat", display: "Demat" },
  { value: "trading", display: "Trading" },
];

export const OptOut = forwardRef((props: any, ref: any) => {
  const [dpOptions, setDpOptions] = useState<any>([]);
  const [selectedDp, setSelectedDp] = useState<any>("");
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [accType, setAccType] = useState<any>("");
  const [errors, setErrors] = useState<any>({
    dp: "",
  });

  useEffect(() => {
    props.dpId({ dpId: selectedDp, accType: accType });
    if (
      dpOptions &&
      dpOptions.length > 0 &&
      selectedDp &&
      accType !== "trading"
    ) {
      let selectedDpElement = dpOptions.find((ele: any) => {
        if (ele.value === selectedDp) return ele;
      });
      if (selectedDpElement && selectedDpElement.Demat_HolderType) {
        if (selectedDpElement.Demat_HolderType === "Joint") {
          props.enableSubmit(false);
          setErrorMsg(
            "It seems that the DP Account is a joint holder account. This request cannot be processed online."
          );
        } else {
          setErrorMsg(undefined);
          if (accType === "trading" || selectedDp) props.enableSubmit(true);
        }
      }
    } else {
      if (accType === "trading" || selectedDp) props.enableSubmit(true);
    }
  }, [selectedDp, accType]);

  useEffect(() => {
    getNomineeDetails();
  }, []);

  useEffect(() => {
    if (dpOptions.length === 2 && !dpOptions[1].value)
      props.enableSubmit(false);
  }, [dpOptions]);

  useImperativeHandle(ref, () => ({
    submitData() {
      let hasErr = false;
      let updateObj: any = {};

      let dpId = selectedDp;

      if (!selectedDp || accType === "trading") {
        //if only trading visible/ trading option selected
        if (props.nomineeDet)
          props.nomineeDet[0].DematDetails.forEach((ele: any) => {
            if (ele.DefaultDemat === "Yes") dpId = ele.Demat_Account_Number;
          });
      }

      if (dpOptions.length > 1 && accType !== "trading") {
        if (!selectedDp) {
          updateObj.dp = "Please select DP Id";
          hasErr = true;
        }
        setErrors({
          ...errors,
          ...updateObj,
        });
      }
      if (!hasErr) {
        let minorClient = "No";
        props.nomineeDet[0].DematDetails.forEach((ele: any) => {
          if (
            ele.Demat_Account_Number === dpId &&
            ele.Minor &&
            ele.Minor.trim()
          )
            minorClient = ele.Minor;
        });
        let reqObj = {
          acTyp: LoginService.getAccData("accTyp"),
          dpId: dpId,
          trdOpt: accType.includes("trading"),
          dpOpt: accType.toLowerCase().includes("demat"),
          trdUpd: accType.includes("trading"),
          dpUpd: accType.toLowerCase().includes("demat"),
          reqTyp:
            (accType === "tradingDemat" && "trading+demat") ||
            (accType === "trading" && "trading") ||
            (accType === "demat" && "demat"),
          nomTyp: "Opt Out",
          minorClient: minorClient,
          subStatus: "Approved",
        };
        return reqObj;
      }
      {
        props.enableSubmit(false);
        return false;
      }
    },
  }));

  const getNomineeDetails = async () => {
    let resp = props.nomineeDet;

    let dpOptions: any = [];
    if (resp.length > 0) {
      resp[0].DematDetails.forEach((ele: any) => {
        if (
          ele.DematTagging !== "Opted Out" &&
          ele.DematTagging !== "OUTSIDE_DP"
        ) {
          let dematAccNo = ele.Demat_Account_Number.trim();
          if (dpOptions.length === 0) {
            dpOptions.push({
              display: "Select DP Details",
              value: "",
            });
          }
          dpOptions.push({
            display: dematAccNo,
            value: dematAccNo,
            ...ele,
          });
        }
      });
      if (dpOptions.length > 2) {
        setDpOptions(dpOptions);
        setSelectedDp(dpOptions[0].value);
        setAccType(accTypes[0].value);
      } else if (dpOptions.length === 2) {
        setDpOptions(dpOptions);
        setSelectedDp(dpOptions[1].value);
        setAccType(accTypes[0].value);
      } else if (dpOptions.length === 0) {
        setErrorMsg("Data in all DPs are updated");
        setAccType(accTypes[2].value);
      }
      // props.enableSubmit(true);
    }
  };

  return (
    <>
      <div className="optOutWrap space-mt-3">
        <AccounTypeSection
          setAccountType={(val: any) => {
            setAccType(val);
            if (val === "trading") {
              setErrorMsg("");
            }
          }}
          onlyTrading={dpOptions.length === 0 ? 1 : ( props.onlyTrading === 1 ? 1 : 0)}
        />
        <DpTrading
          dpOptions={dpOptions}
          selectedAcc={accType}
          selectedDp={selectedDp}
          setSelectedDp={setSelectedDp}
          setErrors={setErrors}
          errors={errors}
          errorMsg={errorMsg}
          accountCode={props.nomineeDet[0].TradingDetails.AccountCode}
        />
      </div>
      {/* <div className="CheckboxWrap">
          <div></div>
          <div className="payment-radio nominationRadio">
            <div className="display-flex tradeDemat">
              {!errorMsg && (
                <div className="radioBtn_wrap">
                  <RadioButton
                    list={accTypes[0]}
                    name="accTypeNomin"
                    onChange={() => {
                      setAccType(accTypes[0].value);
                    }}
                    selected={accType}
                  />
                </div>
              )}

              {!errorMsg && (
                <div className="radioBtn_wrap">
                  <RadioButton
                    list={accTypes[1]}
                    name="accTypeNomin"
                    onChange={() => {
                      setAccType(accTypes[1].value);
                    }}
                    selected={accType}
                  />
                </div>
              )}
              {!(
                errorMsg &&
                errorMsg ===
                  "It seems that the DP Account is a joint holder account. This request cannot be processed online."
              ) && (
                <div className="radioBtn_wrap">
                  <RadioButton
                    list={accTypes[2]}
                    name="accTypeNomin"
                    onChange={() => {
                      setAccType(accTypes[2].value);
                    }}
                    selected={accType}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {dpOptions.length > 2 && accType !== "trading" && (
          <div className="nomination">
            <div>
              <div className="custom--row progressbar_row">
                <div className="form-field custom-col noLeftPAdding">
                  <label className="input-label">DP Details</label>
                  <TocDropdown
                    selectedValue={
                      dpOptions.length > 0 ? selectedDp : "Select DP Details"
                    }
                    dropdownOptions={
                      selectedDp
                        ? dpOptions.filter((ele: any, i: any) => {
                            return i !== 0;
                          })
                        : dpOptions
                    }
                    onSelect={(val) => {
                      if (val) {
                        setSelectedDp(val);
                      }
                    }}
                    isSearchable={false}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {dpOptions.length === 2 && accType != "trading" && (
          <div className="nomination">
            <div>
              <div className="custom--row progressbar_row dpDetails">
                <div className="form-field custom-col noLeftPAdding">
                  <label className="input-label">DP Details</label>

                  <InputField
                    type="text"
                    defaultValue={selectedDp}
                    onChange={() => {}}
                    onBlur={() => {}}
                    placeholder=""
                    disabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {errorMsg && (
          <>
            <br />
            <p className="error-msg">{errorMsg}</p>
          </>
        )} */}
    </>
  );
});
